import { render, staticRenderFns } from "./evaluate_shopDetails.vue?vue&type=template&id=c01d8214&scoped=true"
import script from "./evaluate_shopDetails.vue?vue&type=script&lang=js"
export * from "./evaluate_shopDetails.vue?vue&type=script&lang=js"
import style0 from "./evaluate_shopDetails.vue?vue&type=style&index=0&id=c01d8214&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01d8214",
  null
  
)

export default component.exports